export const POOL_ID = "ap-southeast-1_GgOsKkw4X";
export const CLIENT_ID = "5uvkpnn0q8b1av10heu154cl5a";
export const URL = "http://localhost:3000";
export const URL_AUTH = `https://auth.zcode.id/login?client_id=${CLIENT_ID}&response_type=token&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=${URL}`;
